import './App.css';
import Navbar from './components/navbar/Navbar';
import Banner from './components/banner/Banner';
import Features from './components/features/Features';
import Project from './components/project/Project';
import { HashRouter as Router, Routes, Route } from 'react-router-dom'; // ⬅️ Changed to HashRouter
import ImageGallery from './components/project/ImageGallery';
import VideoGallery from './components/project/VdoGallery';
import Resume from './components/resume/Resume';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';

function App() {
  return (
    <Router>
      <div className="w-full h-auto bg-bodyColor text-lightText px-4">
        <div className="max-w-screen-xl mx-auto">
          <Navbar />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Banner />
                  <Features />
                  <Project />
                  <Resume />
                  <Contact />
                </>
              }
            />
            <Route path="/gallery" element={<ImageGallery />} />
            <Route path="/video-gallery" element={<VideoGallery />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
